import { DealsToProductGroupsProps } from '../../../../../shared/models/EnableUsers';
import { User } from '../../../../../shared/models/UserModels';
import emptySliceApi from '../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    disableUserAccount: builder.mutation<
      User,
      { accountId: string; userId: string }
    >({
      query: ({ accountId, userId }) => ({
        url: `/v4/accounts/${accountId}/users/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
    restoreUser: builder.mutation<
      User,
      {
        accountId: string;
        userId: string;
        productIds: number[];
      }
    >({
      query: ({ accountId, userId, productIds = [] }) => ({
        url: `/v4/accounts/${accountId}/users/${userId}/restore`,
        method: 'PUT',
        body: {
          productAssignments: productIds,
        },
      }),
      invalidatesTags: ['User'],
    }),
    enableUser: builder.mutation<
      User,
      {
        accountId: string;
        accountUserId: string;
        data: DealsToProductGroupsProps[];
      }
    >({
      query: ({ accountId, accountUserId, data }) => ({
        url: `v4/accounts/${accountId}/users/${accountUserId}/restore`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useDisableUserAccountMutation,
  useRestoreUserMutation,
  useEnableUserMutation,
} = apiSlice;
